import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChatNotificationOverrideQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChatNotificationOverrideQuery = { __typename?: 'Query', UserPushNotificationSettingChatOverrides: Array<{ __typename?: 'UserPushNotificationSettingChatOverride', id: string, chatSetting: Types.UserPushNotificationChatSetting, chat: { __typename?: 'Chat', id: string } }> };

export type ChatsPushNotificationSettingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChatsPushNotificationSettingQuery = { __typename?: 'Query', UserPushNotificationSettings: Array<{ __typename?: 'UserPushNotificationSetting', id: string, type: Types.UserPushNotificationSettingType, chatSetting?: Types.UserPushNotificationChatSetting | null }> };

export type SetChatNotificationOverrideMutationVariables = Types.Exact<{
  input: Types.UpdateOrCreateUserPushNotificationSettingChatOverrideInput;
}>;


export type SetChatNotificationOverrideMutation = { __typename?: 'Mutation', updateOrCreateUserPushNotificationSettingChatOverride: { __typename?: 'UserPushNotificationSettingChatOverrideMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, userPushNotificationSettingChatOverride?: { __typename?: 'UserPushNotificationSettingChatOverride', id: string, chatSetting: Types.UserPushNotificationChatSetting, chat: { __typename?: 'Chat', id: string } } | null } };

export type DeleteChatNotificationOverrideMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type DeleteChatNotificationOverrideMutation = { __typename?: 'Mutation', deleteUserPushNotificationSettingChatOverride: { __typename?: 'GenericMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null } };


export const ChatNotificationOverrideDocument = gql`
    query ChatNotificationOverride {
  UserPushNotificationSettingChatOverrides {
    id
    chatSetting
    chat {
      id
    }
  }
}
    `;

/**
 * __useChatNotificationOverrideQuery__
 *
 * To run a query within a React component, call `useChatNotificationOverrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatNotificationOverrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatNotificationOverrideQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatNotificationOverrideQuery(baseOptions?: Apollo.QueryHookOptions<ChatNotificationOverrideQuery, ChatNotificationOverrideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatNotificationOverrideQuery, ChatNotificationOverrideQueryVariables>(ChatNotificationOverrideDocument, options);
      }
export function useChatNotificationOverrideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatNotificationOverrideQuery, ChatNotificationOverrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatNotificationOverrideQuery, ChatNotificationOverrideQueryVariables>(ChatNotificationOverrideDocument, options);
        }
export type ChatNotificationOverrideQueryHookResult = ReturnType<typeof useChatNotificationOverrideQuery>;
export type ChatNotificationOverrideLazyQueryHookResult = ReturnType<typeof useChatNotificationOverrideLazyQuery>;
export type ChatNotificationOverrideQueryResult = Apollo.QueryResult<ChatNotificationOverrideQuery, ChatNotificationOverrideQueryVariables>;
export const ChatsPushNotificationSettingDocument = gql`
    query ChatsPushNotificationSetting {
  UserPushNotificationSettings {
    id
    type
    chatSetting
  }
}
    `;

/**
 * __useChatsPushNotificationSettingQuery__
 *
 * To run a query within a React component, call `useChatsPushNotificationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatsPushNotificationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsPushNotificationSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatsPushNotificationSettingQuery(baseOptions?: Apollo.QueryHookOptions<ChatsPushNotificationSettingQuery, ChatsPushNotificationSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatsPushNotificationSettingQuery, ChatsPushNotificationSettingQueryVariables>(ChatsPushNotificationSettingDocument, options);
      }
export function useChatsPushNotificationSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatsPushNotificationSettingQuery, ChatsPushNotificationSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatsPushNotificationSettingQuery, ChatsPushNotificationSettingQueryVariables>(ChatsPushNotificationSettingDocument, options);
        }
export type ChatsPushNotificationSettingQueryHookResult = ReturnType<typeof useChatsPushNotificationSettingQuery>;
export type ChatsPushNotificationSettingLazyQueryHookResult = ReturnType<typeof useChatsPushNotificationSettingLazyQuery>;
export type ChatsPushNotificationSettingQueryResult = Apollo.QueryResult<ChatsPushNotificationSettingQuery, ChatsPushNotificationSettingQueryVariables>;
export const SetChatNotificationOverrideDocument = gql`
    mutation SetChatNotificationOverride($input: UpdateOrCreateUserPushNotificationSettingChatOverrideInput!) {
  updateOrCreateUserPushNotificationSettingChatOverride(input: $input) {
    success
    error {
      message
    }
    userPushNotificationSettingChatOverride {
      id
      chatSetting
      chat {
        id
      }
    }
  }
}
    `;
export type SetChatNotificationOverrideMutationFn = Apollo.MutationFunction<SetChatNotificationOverrideMutation, SetChatNotificationOverrideMutationVariables>;

/**
 * __useSetChatNotificationOverrideMutation__
 *
 * To run a mutation, you first call `useSetChatNotificationOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChatNotificationOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChatNotificationOverrideMutation, { data, loading, error }] = useSetChatNotificationOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChatNotificationOverrideMutation(baseOptions?: Apollo.MutationHookOptions<SetChatNotificationOverrideMutation, SetChatNotificationOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChatNotificationOverrideMutation, SetChatNotificationOverrideMutationVariables>(SetChatNotificationOverrideDocument, options);
      }
export type SetChatNotificationOverrideMutationHookResult = ReturnType<typeof useSetChatNotificationOverrideMutation>;
export type SetChatNotificationOverrideMutationResult = Apollo.MutationResult<SetChatNotificationOverrideMutation>;
export type SetChatNotificationOverrideMutationOptions = Apollo.BaseMutationOptions<SetChatNotificationOverrideMutation, SetChatNotificationOverrideMutationVariables>;
export const DeleteChatNotificationOverrideDocument = gql`
    mutation DeleteChatNotificationOverride($id: UUID!) {
  deleteUserPushNotificationSettingChatOverride(id: $id) {
    success
    error {
      message
    }
  }
}
    `;
export type DeleteChatNotificationOverrideMutationFn = Apollo.MutationFunction<DeleteChatNotificationOverrideMutation, DeleteChatNotificationOverrideMutationVariables>;

/**
 * __useDeleteChatNotificationOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteChatNotificationOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatNotificationOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatNotificationOverrideMutation, { data, loading, error }] = useDeleteChatNotificationOverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatNotificationOverrideMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatNotificationOverrideMutation, DeleteChatNotificationOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatNotificationOverrideMutation, DeleteChatNotificationOverrideMutationVariables>(DeleteChatNotificationOverrideDocument, options);
      }
export type DeleteChatNotificationOverrideMutationHookResult = ReturnType<typeof useDeleteChatNotificationOverrideMutation>;
export type DeleteChatNotificationOverrideMutationResult = Apollo.MutationResult<DeleteChatNotificationOverrideMutation>;
export type DeleteChatNotificationOverrideMutationOptions = Apollo.BaseMutationOptions<DeleteChatNotificationOverrideMutation, DeleteChatNotificationOverrideMutationVariables>;